import { useEffect } from 'react'

import { Icon } from 'components/atoms/Icon'
import { Logo } from 'components/atoms/Logo'
import { smoothScrollTo } from 'lib/utils'
import type { SidebarProps } from 'components/organisms/Sidebar/types'

import './index.scss'
import {
  Button,
  EButtonStyleVariant,
  EButtonVariant,
} from 'components/atoms/Button'

const mainClass = 'sidebar'

export const Sidebar = ({ menu, isOpen, onClose }: SidebarProps) => {
  const handleMenuClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
    href: string
  ) => {
    smoothScrollTo(href)
    onClose()
  }

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('sidebar-open')
    } else {
      document.body.classList.remove('sidebar-open')
    }

    return () => {
      document.body.classList.remove('sidebar-open')
    }
  }, [isOpen])

  if (!menu || menu.length === 0) {
    return null
  }

  return (
    <aside className={`${mainClass} ${isOpen ? 'active' : ''}`}>
      <div className={`${mainClass}__overlay`} onClick={onClose}></div>
      <div className={`${mainClass}__content`}>
        <div className={`${mainClass}__header`}>
          <a href="/" onClick={onClose}>
            <Logo
              src={'logo'}
              mobSrc={'logo-small'}
              className={`${mainClass}__logo`}
            />
          </a>
          <Button
            variant={EButtonVariant.BUTTON}
            buttonVariant={EButtonStyleVariant.SPECIAL}
            className={`${mainClass}__close`}
            onClick={onClose}
          >
            <Icon name="close" className={`${mainClass}__close-icon`} />
          </Button>
        </div>
        <nav
          className={`${mainClass}__menu`}
          role="navigation"
          aria-label="Mobile navigation"
        >
          {menu.map((item) => (
            <a
              key={item.href}
              className={`${mainClass}__menu-item`}
              href={item.href}
              onClick={(e) => handleMenuClick(e, item.href)}
            >
              {item.text}
            </a>
          ))}
        </nav>
      </div>
    </aside>
  )
}
